<template>
    <div class="container-fluid form-container elighting-certificate-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Fire Extinguisher Certificate
                </h1>
            </div>
        </div>
        <form
            action=""
            class="fire-ex-certificate"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="doc_no">Invoice No.</label>
                            <input
                                type="text"
                                id="invoice_no"
                                name="doc_no"
                                v-model="form.invoice_no"
                                placeholder="Invoice No."
                                class="form-control"
                            >
                            <error
                                name="invoice_no"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                id="po_number"
                                name="po_number"
                                v-model="form.po_number"
                                placeholder="Purchase Order No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="po_number"
                            />
                        </div>
                        
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="expire_date">Expire Date</label>
                            <date-picker
                                v-model="form.expire_date"
                                id="expire_date"
                                :options="{format: 'MM/YYYY'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="expire_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <table class="table qty-table">
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>WATER</td>
                                    <td>FOAM</td>
                                    <td>POWDER</td>
                                    <td>CO2</td>
                                </tr>
                                <tr>
                                    <td>QTY</td>
                                    <td>
                                        <input
                                            type="number"
                                            placeholder="0"
                                            min="0"
                                            max="999"
                                            v-model="form.water_total"
                                            class="form-control"
                                        >
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            placeholder="0"
                                            min="0"
                                            max="999"
                                            v-model="form.foam_total"
                                            class="form-control"
                                        >
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            placeholder="0"
                                            min="0"
                                            max="999"
                                            v-model="form.powder_total"
                                            class="form-control"
                                        >
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            placeholder="0"
                                            min="0"
                                            max="999"
                                            v-model="form.co2_total"
                                            class="form-control"
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>WET CHEMICAL</td>
                                    <td>FIRE BLANKET</td>
                                    <td>HOSES</td>
                                    <td>SCREAMER ALARM</td>
                                </tr>
                                <tr>
                                    <td>QTY</td>
                                    <td>
                                        <input
                                            type="number"
                                            placeholder="0"
                                            min="0"
                                            max="999"
                                            v-model="form.wet_chem_total"
                                            class="form-control"
                                        >
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            placeholder="0"
                                            min="0"
                                            max="999"
                                            v-model="form.fire_blanket_total"
                                            class="form-control"
                                        >
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            placeholder="0"
                                            min="0"
                                            max="999"
                                            v-model="form.hoses_total"
                                            class="form-control"
                                        >
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            placeholder="0"
                                            min="0"
                                            max="999"
                                            v-model="form.screamer_alarm_total"
                                            class="form-control"
                                        >
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_name"
                                class="top"
                            >Engineer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.engineer_sign_name"
                                id="engineer_sign_name"
                                name="engineer_sign_name"
                                placeholder="Engineer Name"
                                class="form-control"
                                @input="engineerNameChanged"
                            >
                            <error
                                :errors="errors"
                                name="engineer_sign_name"
                            />
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="responsible_sign_name"
                                class="top"
                            >Responsible Person's Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.responsible_sign_name"
                                id="responsible_sign_name"
                                name="responsible_sign_name"
                                placeholder="Responsible Person's Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="responsible_sign_name"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit'"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import datePicker from "../DateTimePickerComponent.vue";
import CustomerSearchComponent from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import * as moment from "moment";
import AuthService from "../../services/AuthService";
import FormService from "../../services/FormService";
import JobService from "../../services/JobService";
import UsersService from "../../services/UsersService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";

export default {
    components: {
        "customer-search": CustomerSearchComponent,
        "date-picker": datePicker,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        UsesFormRouteQuery,
    ],
    props: {
        formId: {
            default: () => null
        },
    },
    data: function () {
        return {
            officeStaff: [],
            changed: false,
            sites: [],
            jobs: [],
            form: {
                type: "fire_ex_certificate",
                customer: {
                    company_name: "",
                },
                job_id: null,
                site_id: null,
                expire_date: moment().add(12, 'months'),
            },
            water_total: 0,
            foam_total: 0,
            powder_total: 0,
            co2_total: 0,
            wet_chem_total: 0,
            fire_blanket_total: 0,
            hoses_total: 0,
            screamer_alarm_total: 0,

            token: null,
        };
    },
    computed: {
        canDelete: function () {
            return AuthService.user.admin_access || AuthService.user.office_access;
        },
    },
    mounted: function () {

        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then(res => {
                this.form.doc_no = res.data;
            });
        }

        this.getOfficeStaff();

        if (typeof this.$route.query.fire_ex_form !== 'undefined') {
            this.loadFireExForm(this.$route.query.fire_ex_form);
        }
    },
    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id).then(res => {
                this.form = res.data;
                this.getJobs();
                if (res.data.expire_date) {
                    this.form.expire_date = moment(res.data.expire_date);
                } else {
                    this.form.expire_date = moment();
                }
            }, err => {
                this.setErrorMessage('Could not load form');
            }).then(() => {
                this.clearLoading();
            });
        },
        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                }
            } else {
                this.form.site_id = '';
            }
            this.getJobs();
        },
        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({'filter[customer_id]': this.form.customer_id}).then(res => {
                this.jobs = res.data.data || [];
            }, err => {
                this.setErrorMessage('Could not load customer jobs');
            });
        },
        saveForm: function () {
            this.setSaving();
            let data = {...this.form};
            delete data['customer'];
            delete data['site'];
            delete data['job'];
            delete data['data'];
                
            if (this.form.id) {
                Service.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                Service.create(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },
        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    xhr => {
                        this.setInfoMessage("Form successfully deleted");
                        // TODO: Redirect to relavant page
                        this.$router.push({name: 'office.forms.search'});
                    },
                    error => {
                        this.setErrorMessage("Could not delete this form");
                    }
                );
            }
        },

        getOfficeStaff: function () {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    xhr => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        engineerNameChanged: function () {

        },

        responsibleNameChanged: function () {

        },

        forceUpdate: function () {
            this.$forceUpdate();
        },

        loadFireExForm: function (form_id) {
            this.form.fire_ex_form_id = form_id;
            FormService.get(form_id).then(xhr => {
                const testForm = xhr.data;
                this.form.customer = testForm.customer;
                this.form.customer_id = testForm.customer_id;
                this.form.site_id = testForm.site_id;
                if (testForm.engineer_sign_date) {
                    this.form.expire_date = moment(testForm.engineer_sign_date).add(12, 'months');
                }
                this.form.engineer_sign_name = testForm.engineer_sign_name;
                if (testForm.engineer) {
                    this.form.engineer_sign_name = testForm.engineer.name;
                }
                this.form.responsible_sign_name = testForm.customer_sign_name;
                this.form.water_total = testForm.water_total;
                this.form.foam_total = testForm.foam_total;
                this.form.powder_total = testForm.powder_total;
                this.form.co2_total = testForm.co2_total;
                this.form.wet_chem_total = testForm.wet_chem_total;
                this.form.hoses_total = testForm.hoses_total;
                this.form.fire_blanket_total = testForm.blanket_total;
                this.form.screamer_alarm_total = testForm.screamer_total;
            }, error => {
                this.setErrorMessage('Could not load original form');
            });
        }
    }
}
</script>
<style lang="scss" scoped>
    .qty-table {
        td {
            text-align: center;
            width: 20%;
        }

        input {
            text-align: center;
        }
    }

</style>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/FireExCertificateComponent.vue